import { useEntryPriceAfterSpread } from '@ui/features/Trade/hooks/useEntryPriceAfterSpread';
import { PossibleBigNumber } from '@ui/types/utility';
import { isNil } from 'lodash-es';

import { usePositionSize } from './usePositionSize';

export const useToAmount = (inputUsd: PossibleBigNumber) => {
  const positionSize = usePositionSize({ inputUsd });
  const entryPrice = useEntryPriceAfterSpread();

  if (isNil(positionSize) || isNil(entryPrice)) return undefined;

  return positionSize.div(entryPrice);
};
